module.exports = __webpack_public_path__ + "static/media/calendar.2c863fe8.svg";